__turbopack_context__.v({
  "wrap": "GlobalNetworkIndicator-module__zSlG5a__wrap",
});
